
<style>
</style>
<template>
    <el-row >
        <table-template :queryParams="queryParams" actionUrl="icon/findIconNavigationList.action"
                        ref="Table">
            <template slot="search">
                <el-row :gutter="10">
                    <el-col :span="5">
                         <el-button style="margin-left:10px;margin-bottom: 10px" type="primary" @click="$router.push({path:'/home/saveNavigationDialog'})">新增导航</el-button>
                     </el-col>
                    <el-col style="width: 100px;margin-top: 10px">导航样式</el-col>
                    <el-col :span="12" >
                        <el-radio-group  style="margin-top: 15px"  @change="updateChannelStyleType()" v-model="styleType">
                            导航样式
                                <el-radio :label="2"> 双排 5x2</el-radio>
                            <el-radio :label="3">三排 5x3</el-radio>
                        </el-radio-group>

                    </el-col>
               </el-row>

            </template>
<template slot="item" >
    <el-table-column label="icon图">
        <template scope="scope">
            <img style="width: 83px;height: 83px;" :src="scope.row.img" class="basic-margin" />
        </template>
    </el-table-column>

    <el-table-column label="icon名称">
        <template scope="scope">
            <span >{{scope.row.name}}</span>
        </template>
    </el-table-column>

    <el-table-column label="排序值">
        <template scope="scope">
            <span>{{scope.row.sort}}</span>
        </template>
    </el-table-column>

    <el-table-column label="跳转内容">
        <template scope="scope">
            <span>{{scope.row.skipUrl}}</span>
        </template>
    </el-table-column>

    <el-table-column label="状态" width="300">
        <template scope="scope">
            <el-switch
                    @change='changeNavigationStatus(scope.row.id,scope.row.status)'
                    v-model="scope.row.statusResult"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
            </el-switch>
        </template>
    </el-table-column>

    <el-table-column label="操作" width="250">
        <template scope="scope">

            <el-button type="danger"  size="small" @click="deleteNavigation(scope.row.id)">删除</el-button>
            <el-button type="warning"  size="small"  @click="$router.push({name:'编辑首页icon导航', params: { id: scope.row.id }})">编辑</el-button>
        </template>
    </el-table-column>
</template>
</table-template>
</el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import IconModel from '@/framework/models/iconModel'
import CdChannelModel from '@/framework/models/channelModel'

export default {
  name: 'navigation-management',
  components: {
    TableTemplate
  },
  extends: BasicPager,
  data: function () {
    return {
      styleType: 3,
      queryParams: {
        channelId: null
      }
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.queryParams.channelId = userInfo.id
    this.selectChannelConfig()
  },
  methods: {

    selectChannelConfig: function () {
      let userInfo = JSON.parse(localStorage.userInfo)
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      }
      let _this = this
      let param = { 'id': id }
      let listener = {
        success: function (dataInfo) {
          _this.styleType = dataInfo.datas.styleType
        }
      }
      CdChannelModel.selectChannelConfig(_this, param, listener)
    },
    updateChannelStyleType: function () {
      let userInfo = JSON.parse(localStorage.userInfo)
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      }
      let _this = this
      let param = { 'id': id, 'styleType': this.styleType }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
          } else {
            _this.$message({
              message: '修改失败！',
              type: 'error'
            })
          }
        }
      }
      IconModel.updateChannelStyleType(_this, param, listener)
    },
    search: function () {
      this.$refs.Table.search()
    },
    changeNavigationStatus: function (id, status) {
      let _this = this
      let params = {
        id: id,
        status: status === 1 ? 2 : 1
      }
      let listener = {
        success: function (dataInfo) {
          _this.$refs.Table.search()
          _this.$message({
            type: 'success',
            message: '状态修改成功'
          })
        }
      }
      IconModel.changeNavigationStatus(this, params, listener)
    },
    deleteNavigation: function (id) {
      let _this = this
      this.$confirm('您是否要删除该图标?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          id: id
        }
        let listener = {
          success: function (dataInfo) {
            _this.$refs.Table.search()
            _this.$message({
              type: 'success',
              message: '删除成功'
            })
          }
        }
        IconModel.deleteNavigation(this, params, listener)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
